// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, P } from '@a-type/ui';
import { lazy, Suspense } from 'react';
import { useSnapshot } from 'valtio';
import { useLocalStorage } from '../hooks/useStorage.js';
import { installState } from '../install.js';
import { getIsPWAInstalled } from '../platform.js';
const InstallButton = lazy(() => import('./InstallButton.js'));
export function InstallHint({ content: contentStr, className, }) {
    const [isDismissed, setIsDismissed] = useLocalStorage('pwa-install-hint-dismissed', false);
    const { installReady } = useSnapshot(installState);
    if (isDismissed || getIsPWAInstalled() || !installReady) {
        return null;
    }
    return (_jsxs(Box, { surface: "primary", p: true, d: "col", gap: true, items: "stretch", className: className, children: [_jsx(P, { children: contentStr }), _jsxs("div", { className: "flex flex-row items-center justify-end gap-4 w-full", children: [_jsx(Button, { color: "ghost", onClick: () => setIsDismissed(true), children: "Dismiss" }), _jsx(Suspense, { fallback: _jsx(Button, { size: "small", disabled: true, loading: true, color: "ghost", children: "..." }), children: _jsx(InstallButton, { color: "primary" }) })] })] }));
}
//# sourceMappingURL=InstallHint.js.map